import type { DuplicateActivityDraft } from '../../../utils/duplicate-activity.util';
import { EventEmitter } from '@angular/core';
import { GeoLocality } from '../../locations/domains/geo-locality';
import { GeoPosition } from '../../locations/domains/geo-position';

export class ResetCreateEventAction {
  static readonly type = '[CreateEvent] ResetCreateEventAction';
}

export class ResetJustCreatedAction {
  static readonly type = '[CreateEvent] ResetJustCreated';
}

export class SetTitleCreateEventAction {
  static readonly type = '[CreateEvent] SetTitleCreateEventAction';

  constructor(public payload: string) {}
}

export class SetPrivacyCreateEventAction {
  static readonly type = '[CreateEvent] SetPrivacyCreateEventAction';

  constructor(public payload: 'public' | 'private' | 'members_only') {}
}

export class SetBackgroundImgCreateEventAction {
  static readonly type = '[CreateEvent] SetBackgroundImgCreateEventAction';

  constructor(public payload: string) {}
}

export class SelectDateAndTimeCreateEventAction {
  static readonly type = '[CreateEvent] SelectDateAndTimeCreateEventAction';

  constructor(
    public payload: { date: string; startHours: number; startMinutes: number; repeatWeekly: boolean; dateEnd: string },
  ) {}
}

export class SelectSportIdCreateEventAction {
  static readonly type = '[CreateEvent] SelectSportIdCreateEventAction';

  constructor(public payload: { sportId: string; sportKeyId: string }) {}
}

export class SelectSessionKindCreateEventAction {
  static readonly type = '[CreateEvent] SelectSessionKindCreateEventAction';

  constructor(public payload: string) {}
}

export class SetGroupIdCreateEventAction {
  static readonly type = '[CreateEvent] SetGroupIdCreateEventAction';

  constructor(public payload: string) {}
}

export class SetGroupNameCreateEventAction {
  static readonly type = '[CreateEvent] SetGroupNameCreateEventAction';

  constructor(public payload: string) {}
}

export class SetDurationActivityCreateEventAction {
  static readonly type = '[CreateEvent] SetDurationActivityCreateEventAction';

  constructor(
    public payload: {
      duration?: number;
      distance?: number;
      pace?: string;
      verticalDrop?: number;
    },
  ) {}
}

export class SelectLocationActivityCreateEventAction {
  static readonly type = '[CreateEvent] SelectLocationActivityCreateEventAction';

  constructor(public payload: { coordinates: GeoPosition; locality: GeoLocality }) {}
}

/**
 * SMA-103: where the outing ends, when that is not where it starts.
 *
 * An undefined payload clears it. Somebody who picked an arrival and then
 * changed the outing back to a loop has to be able to take it away, and on a
 * form the gesture for that is emptying the field.
 */
export class SelectEndLocationActivityCreateEventAction {
  static readonly type = '[CreateEvent] SelectEndLocationActivityCreateEventAction';

  constructor(public payload?: { coordinates: GeoPosition; locality: GeoLocality }) {}
}

export class SelectAttendeesCreateEventAction {
  static readonly type = '[CreateEvent] SelectAttendeesCreateEventAction';

  constructor(
    public payload: {
      maxAttendees: number;
      acceptAnyLvl: boolean;
      attendeesMode: 'preset' | 'manual';
      handiFriendly?: boolean;
      // Optional confirmation threshold, expressed as registrants besides the
      // organiser (so one or more). The +1 for the organiser is added when the
      // activity is created, exactly like maxAttendees.
      minParticipants?: number;
    },
  ) {}
}

export class SetDescriptionCreateEventAction {
  static readonly type = '[CreateEvent] SetDescriptionCreateEventAction';

  constructor(public payload: string) {}
}

export class SetRouteUrlCreateEventAction {
  static readonly type = '[CreateEvent] SetRouteUrlCreateEventAction';

  constructor(public payload: string | undefined) {}
}

export class CreateEventAction {
  static readonly type = '[CreateEvent] CreateEventAction';
}

export class OnCancelCreateEventAction {
  static readonly type = '[CreateEvent] OnCancelCreateEventAction clicked';

  constructor(public payload: { title: string; mode?: string; fctBack?: EventEmitter<void> | null }) {}
}

export class SetTypeCreateEventAction {
  static readonly type = '[CreateEvent] SetTypeCreateEventAction';

  constructor(public payload: 'paid' | 'free') {}
}
export class SetAcceptCommissionCreateEventAction {
  static readonly type = '[CreateEvent] SetAcceptCommissionCreateEventAction';

  constructor(public payload: boolean) {}
}
export class SetCostPerParticipantCreateEventAction {
  static readonly type = '[CreateEvent] SetCostPerParticipantCreateEventAction';

  constructor(public payload: number) {}
}

export class SetCommissionAndCgvCreateEventAction {
  static readonly type = '[CreateEvent] SetCommissionAndCgvCreateEventAction';

  constructor(public payload: { commissionId: string; cgvId: string }) {}
}
export class SetCommissionRateEventAction {
  static readonly type = '[CreateEvent] SetCommissionRateEventAction';

  constructor(public payload: { commissionRate: number }) {}
}

/** Starts the creation form from a copy of an existing activity. */
export class DuplicateActivityCreateEventAction {
  static readonly type = '[CreateEvent] DuplicateActivityCreateEventAction';

  constructor(public payload: DuplicateActivityDraft) {}
}
